import { useState } from "react";
import { Checkbox, FormControlLabel, FormHelperText, Box, Button } from "@mui/material";
import Modal from "react-responsive-modal";
import { useTranslation } from "react-i18next";

export default function PrivacyPolicyCheckbox({ checked, onChange, error, helperText, policyHtml }) {
  const [open, setOpen] = useState(false);
  const [modalChecked, setModalChecked] = useState(false);
  const { t } = useTranslation();

  const handleMainCheckboxChange = (e) => {
    const newValue = e.target.checked;
    if (newValue) {
      setModalChecked(false);
      setOpen(true);
    } else {
      onChange(false);
    }
  };

  const handleAccept = () => {
    onChange(true);
    setModalChecked(false);
    setOpen(false);
  };

  const handleCancel = () => {
    setModalChecked(false);
    onChange(false);
    setOpen(false);
  };

  const handleCloseModal = () => {
    setModalChecked(false);
    onChange(false);
    setOpen(false);
  };

  return (
    <Box sx={{ mb: 1 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={handleMainCheckboxChange}
            sx={{
              color: "#f5272b",
              "&.Mui-checked": { color: "#f5272b" },
            }}
          />
        }
        label={
          <span
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() => {
              setModalChecked(false);
              setOpen(true);
            }}
          >
            {t("i_have_read_and_accept")}
          </span>
        }
      />
      {error && <FormHelperText error>{helperText}</FormHelperText>}

      <Modal
        open={open}
        onClose={handleCloseModal}
        showCloseIcon={true}
        styles={{
          root: { zIndex: 9999999991 },
          modal: { backgroundColor: "transparent" },
        }}
      >
        <Box
          sx={{
            p: 3,
            bgcolor: "background.paper",
            maxWidth: 700,
            width: "85vw",
            mx: "auto",
            my: "5%",
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <div
            style={{ maxHeight: "70vh", overflowY: "auto", marginBottom: 16 }}
            dangerouslySetInnerHTML={{
              __html: `
      <style>
        ul, ol {
          margin-left: 1.5rem;
          padding-left: 1.2rem;
        }
        ul {
          list-style-type: disc; /* bullet dot */
        }
        ol {
          list-style-type: disc; /* angka */
        }
        li {
          margin-bottom: 0.4rem;
          line-height: 1.6;
        }
        h2 {
          color:black;
          font-weight:bold;
          font-size:11px;
          }
      </style>
      ${policyHtml}
    `,
            }}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={modalChecked}
                onChange={(e) => setModalChecked(e.target.checked)}
                sx={{
                  color: "#f5272b",
                  "&.Mui-checked": { color: "#f5272b" },
                }}
              />
            }
            label={t("i_accept_the_privacy")}
          />

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={handleCancel} sx={{ color: "black" }}>
              {t("cancel")}
            </Button>
            <Button
              variant="contained"
              onClick={handleAccept}
              disabled={!modalChecked}
              sx={{
                bgcolor: "#f5272b",
                color: "white",
                "&:hover": { backgroundColor: "#f5272b" },
              }}
            >
              {t("confirm")}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
